let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: 'ZD-BOX型号名称',
    props: '',
    minWidth: 180,
  },

  {
    label: '型号编号',
    props: '',
    minWidth: 180,
    tooltip: true,
  },
  {
    label: '储能电池数量',
    props: '',
    minWidth: 200,
  },
  {
    label: '储能电池总容量',
    props: '',
    minWidth: 120,
  },
  {
    label: '编辑人',
    props: '',
    minWidth: 160,
  },
];

// 面包屑
pageConfig.listBreadCrumb = [
  {
    type: 'title',
    name: '首页',
  },
  {
    type: 'title',
    name: '充电管理'
  },
  {
    type: 'title',
    name: 'zd-box型号管理'
  }
];

// 详情面包屑
pageConfig.detailBreadCrumb = [
  {
    type: 'title',
    name: '首页',
  },
  {
    type: 'title',
    name: '充电管理'
  },
  {
    type: "router",
    name: 'zd-box型号管理',
    router: "ZDBoxModelManage"
  },
  {
    type: "title",
    name: "型号详情"
  }
];

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "ZDBoxModelDetail"
};

// 表单校验
pageConfig.formRules = {
  stationName: [
    { required: true, message: '请输入型号名称', trigger: 'blur' },
  ],
  parkRate: [
    { required: true, message: '请输入型号编号', trigger: 'blur' },
  ],
};

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
}

export default pageConfig;
